
export const convertToMap = (data = [], field = "") => {
  return data.reduce((acum, item) => {
    acum[item[field]] = item;
    return acum;
  }, {});
};
export const convertToMapMultiple = (data = [], field = "") => {
  const newData = {};
  data.forEach((item) => {
    newData[item[field]] = newData[item[field]]
      ? [...newData[item[field]], item]
      : [item];
  });
  return newData;
};
export const convertToNestedMap = (data = [], field = "", nestedField = "") => {
  let newData = {};
  data.forEach((item) => {
    newData[item[field]] = newData[item[field]]
      ? [...newData[item[field]], item]
      : [item];
  });
  // eslint-disable-next-line
  for (const i in newData) {
    newData[i] = convertToMapMultiple(newData[i], nestedField);
  }

  return newData;
};

export const convertToMapById = (data) => {
  try {
    return Object.keys(data)?.map(key => data[key])
  } catch (error) {
    return new Error('Error al convertir')
  }
}